interface SeparatorProps {
  text?: string
  noMargin?: boolean
}

export default function Separator({ text, noMargin = false }: SeparatorProps) {
  return (
    <>
      {Boolean(text) && (
        <div className={`w-full ${!noMargin && 'my-8'}`}>
          <div className="inline-block border-t border-gray-400 w-5/12 mb-1" />
          <div className="inline-block w-2/12">
            <p className="text-center text-sm">{text}</p>
          </div>
          <div className="inline-block border-t border-gray-400 w-5/12 mb-1" />
        </div>
      )}
      {!Boolean(text) && (
        <div
          className={`border-t border-gray-400 w-full px-10 ${!noMargin && 'my-8'}`}
        />
      )}
    </>
  )
}
